/**
 * Shared navigation section container.
 *
 * Wraps a list of NavItem components with consistent spacing.
 * Used by both the primary sidebar and settings sidebar.
 */

interface NavSectionProps {
  children: React.ReactNode;
  /** Additional CSS classes. */
  className?: string;
}

export function NavSection({ children, className }: NavSectionProps) {
  return (
    <ul className={`flex flex-col px-2 lg:px-4 ${className ?? ''}`}>
      {children}
    </ul>
  );
}
